import React, {useState, useEffect} from 'react';
import Slider from 'components/Slider';
import Hours from './Hours';
import RadioButton from 'components/RadioButton';
import Moment from 'moment';
import Price from "components/Price";
import PropTypes from 'prop-types';
import style from './style.scss'; //NOSONAR


const DateDeliveryMobile = ({formatMonth, formatDay, days, hours, _selectedHours, changeDate, callback, dateOrderForm, daySelected,_getHours, getWindowsOrderForm, deliverySelected, date, _getCompleteMonthDays, express, validateExpress, title }) => {

    const [daySelect, setDaySelected] = useState(null);
    const [showDays, setShowDays] = useState(false);
    const [selectExpress, setSelectExpress] = useState(false);

    useEffect(() => {
        setShowDays(false);

        setTimeout(() => {
            setShowDays(true);
        }, 0);
    },[date]);

    useEffect(() => {
        setDaySelected(daySelected);
    },[daySelected]);

    useEffect(() => {
        if(deliverySelected && (deliverySelected !== {}) && deliverySelected.startDateUtc){
            setDaySelected(deliverySelected.startDateUtc.split('T')[0]);
    
            _getHours(deliverySelected.startDateUtc.split('T')[0], deliverySelected, true);
        }
    },[deliverySelected]);

    useEffect(() => {
        if(express){
            setSelectExpress(express.selected)
        }
    }, [express && express.selected])

    const onClickMonth = (i) => {
        const months = formatMonth(dateOrderForm);
        const month = months[i];
        const date = month.value.startDateUtc.split('T')[0];
        const newDate = date.split('-')[0] + '-' + date.split('-')[1] + '-' + date.split('-')[2];


        _getCompleteMonthDays(newDate, newDate);
    }

    let isSelected = hours && hours.length > 0 ? hours : [];
    isSelected = (isSelected.findIndex(item => item.selected) !== -1) || (express && express.selected);

    const months = formatMonth(dateOrderForm);
    const today = Moment().format('YYYY-MM-DD');

    return (
        <div className="new-modal-container">
            <div className="new-modal-scroll">
                
                <span className="new-modal-title">{title ? title : 'Horario de entrega'}</span>

                <div className="modal-date-delivery-months-options">
                    <Slider arrows={true} callback={onClickMonth} className="slider-months">
                        <>
                            {months && months.map((item, i) => {
                                return (
                                    <span className="date-delivery-month" key={i}>{item.label}</span>
                                )
                            })}
                        </>
                    </Slider>
                </div>

                <div className="date-delivery-select-day">
                        Selecciona una fecha
                </div>

                <div className="date-delivery-slider-container">
                    {(showDays && days && (days.length > 0 )) &&
                        <Slider arrows={true} className="date-delivery-slider">
                            <div className="date-delivery-slide">
                                {date && date.map((item, i) => {
                                    const dayWeek = item.split('-')[2];
                                    const hoursDay = getWindowsOrderForm(item);
                                    return (
                                        <div key={i} className={"date-delivery-calendar-week" + ((daySelect == item)  ? ' select-date' : '') + ((!hoursDay.length && (i!=0 || (express && !express.validate))) ? ' no-available' : '')} onClick={() => _getHours(item)}>
                                            <span className="date-delivery-day-name-week">{formatDay(item)}</span>
                                            <span className="date-delivery-day-number-week">{dayWeek}</span>
                                        </div>
                                    )
                                })}
                            </div>
                        </Slider>}
                </div>

                {!!(hours && hours.length) || ((express && express.validate) && (daySelect === today)) && daySelect ? <div className="date-delivery-select-hours">
                    Selecciona el horario para la entrega
                </div> : ''}

                {/* && (!express.validate)  */}
                {((express && !!express.validate) && (daySelect === today)) || (!hours || !hours.length) && daySelect && <div className="date-delivery-hours-not-available">
                    <span className="date-delivery-hours-not-available-text">No tenemos horarios de entrega disponibles para esta jornada</span> 
                    <span className="date-delivery-change-day-text">Por favor, intenta con otro día</span>
                </div>}

                <div className="date-delivery-delivery-time-wrap">
                    <div className="date-delivery-hours-scroll">

                        {(express && express.validate) && (daySelect === today) && <div className="date-delivery-express">
                            <RadioButton item={selectExpress} name={'date-delivery'} callbackSelect={validateExpress} className="date-delivery-express-radio"/>
                            <div className="date-delivery-hours-and-price">
                                <span className={"date-delivery-hour"}> {express.time} minutos </span>
                                <span className="date-delivery-price"><Price price={((express.price / 100) < 1) ? 1 : (express.price / 100)} /></span>
                            </div>
                        </div>}
                        {hours && hours.map((hour, i) => {
                            return (
                                <Hours hour={hour} key={i} callback={_selectedHours} />
                            )
                        })}
                    </div>
                </div>

            </div>

            {hours && <div className="modal-actions">
                <button onClick={() => {callback(false)}} className="secundary-btn date-delivery-canceled-button">Cancelar</button>
                <button onClick={() => changeDate()} className={"disabled-btn date-delivery-selected-button" + (isSelected ? ' primary-btn ' : '')}>Seleccionar</button>
            </div>}
        </div>
    )
}
DateDeliveryMobile.propTypes = {
    formatMonth: PropTypes.func,
    dateOrderForm: PropTypes.array,
    daysAvailables: PropTypes.array,
    formatDay: PropTypes.func,
    isLoading: PropTypes.bool,
    _selectedHours: PropTypes.func,
    changeDate: PropTypes.func,
    days: PropTypes.array,
    deliverySelected: PropTypes.object,
    hours: PropTypes.array,
    _getHours: PropTypes.func,
    callback: PropTypes.func,
    daySelected: PropTypes.string,
    date: PropTypes.array,
    _getCompleteMonthDays: PropTypes.func,
    getWindowsOrderForm: PropTypes.func,
    express: PropTypes.object,
    validateExpress: PropTypes.func,
    title: PropTypes.string
};

export default DateDeliveryMobile;
